import React from 'react';

import parse from 'html-react-parser';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const list = [
    {
        title: '01. Конкуренция',
        subtitle:
            'В&nbsp;большинстве поисковых запросов выдача не&nbsp;зависела от&nbsp;географического положения пользователя. Это значит, что клиент конкурировал в&nbsp;поисковой выдаче с&nbsp;производителями и&nbsp;дилерами по&nbsp;всей стране, но&nbsp;у&nbsp;других производителей оборудование и&nbsp;его конфигурация проще, что создавало дополнительные сложности в&nbsp;позиционировании.',
    },
    {
        title: '02. Ограниченный ассортимент',
        subtitle:
            'Ассортимент товаров довольно ограничен, так как РМ&nbsp;Нанотех&nbsp;&mdash; монобренд. А&nbsp;в&nbsp;SEO выигрывают сайты с&nbsp;большим объемом товаров. Если по&nbsp;ключевому запросу сайт выдает много товаров одного типа, то&nbsp;поисковая система продвигает вверх этот интернет-ресурс.',
    },
    {
        title: '03. Специфическая продукция',
        subtitle:
            'Сложно писать качественный контент в&nbsp;такой нише. Мембранная продукция&nbsp;&mdash; это технологичный товар, который не&nbsp;встречается пользователю на&nbsp;каждом углу. Поэтому было достаточно проблемно настроиться на&nbsp;общий лад со&nbsp;специалистами компании для создания хорошего контента.',
    },
    {
        title: '04. Тематические доноры',
        subtitle:
            'Поиск качественных тематических доноров для размещения ссылок. Нам нужны были только узкоспециализированные, которые подходят по&nbsp;определенным параметрам: насколько достоверный источник, его репутация, как часто обновляется и&nbsp;какой трафик на&nbsp;сайте, желательно тематичный.',
    },
];

const Complex = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper className="nanoteh-complex" bigPaddings={true} isMargin={false}>
                <div className="nanoteh-complex__wrapper">
                    <div className="nanoteh-complex__text">
                        <CommonTitle>Сложности</CommonTitle>
                        <CommonUsualText className="nanoteh-complex__subtitle"></CommonUsualText>
                    </div>
                    <div className="nanoteh-complex__info-list">
                        {list.map(({ title, subtitle }, index) => (
                            <ScrollAnimation
                                animateIn="fadeIn"
                                offset={100}
                                animateOnce={true}
                                duration={1}
                                className="nanoteh-complex__info-item"
                                key={index}
                            >
                                <CommonSmallTitle className="nanoteh-complex__info-title">
                                    {parse(title)}
                                </CommonSmallTitle>
                                <CommonSmallText className="nanoteh-complex__info-subtitle">
                                    {parse(subtitle)}
                                </CommonSmallText>
                            </ScrollAnimation>
                        ))}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Complex;
